import script from "./LoginNavbar.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginNavbar.vue?vue&type=script&setup=true&lang=js"

import "./LoginNavbar.vue?vue&type=style&index=0&id=accdf502&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-accdf502"]])

export default __exports__